// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"c3df616b","157":"6d2f984f","883":"13df55ea"}[chunkId] + ".chunk.css";
};